import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { GenericHttpService } from "./../../../shared/services/generic-http.service";
import { environment } from "../../../../environments/environment";

@Injectable()
export class DataService {
  constructor(private generic: GenericHttpService) { }
  Allvalues;
  apiUrl = environment.gateWayHost;
  getData(url, params?, config?) {
    //var Allvalues;
    const option = {
      method: "GET",
      // url: `${this.apiUrl}${this.apiUrlConstant.getOverallOtif}`,
      url: `${this.apiUrl}${url}`,
      query: params
    };
    const functionToCall = config.functionToCall ? this[config.functionToCall].bind(this) : null;
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToCall || this.generic.responseData)
    );
  }

  processWarehouseOutboundHighlights(data) {
    const originalData = data.data[0][Object.keys(data.data[0])[0]];
    if (!originalData) return null;

    const dataToReturn = originalData.filter((ele) => {
      return (ele.origin_region === "Total");

    }).map(ele => {
      return {
        percentage: Number(ele.sla.toFixed(1)),
        comparison: 0
      };
    })

    if (dataToReturn[0].percentage === 0) return null;
    return dataToReturn;
  }

  processWarehouseInboundHighlights(data) {

    const originalData = data.data[0][Object.keys(data.data[0])[0]];
    if (!originalData) return null;

    const dataToReturn = originalData.filter((ele) => {
      return (ele.destination_region === "Total");
    }).map(ele => {
      return {
        percentage: Number(ele.sla.toFixed(1)),
        comparison: 0
      };
    });
    if (dataToReturn[0].percentage === 0) return null;

    return dataToReturn;
  }

}
